"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexItem = void 0;
var react_1 = __importDefault(require("react"));
exports.FlexItem = function (props) {
    var style = {};
    var children = props.children, rest = __rest(props, ["children"]);
    if (props.width)
        style.width = props.width;
    if (props.height)
        style.height = props.height;
    if (props.flex)
        style.flex = props.flex;
    if (props.grow)
        style.flexGrow = props.grow;
    if (props.basis)
        style.flexBasis = props.basis;
    if (props.shrink)
        style.flexShrink = props.shrink;
    if (props.alignSelf)
        style.alignSelf = props.alignSelf;
    return (react_1.default.createElement("div", __assign({ style: style }, rest), children));
};
//# sourceMappingURL=FlexItem.js.map